import { render, staticRenderFns } from "./OverdueDays.vue?vue&type=template&id=7bebd383&scoped=true&"
import script from "./OverdueDays.vue?vue&type=script&lang=js&"
export * from "./OverdueDays.vue?vue&type=script&lang=js&"
import style0 from "./OverdueDays.vue?vue&type=style&index=0&id=7bebd383&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bebd383",
  null
  
)

export default component.exports